import { useState, useEffect, useRef } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { protectedResources } from "../auth-provider";
 
export const useGetToken = () => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [token, setToken] = useState(null);
    const hasRequestedInteraction = useRef(false);
 
    useEffect(() => {
        if (instance && account && inProgress === InteractionStatus.None) {
            instance.acquireTokenSilent({
                scopes: protectedResources.adminPortalBackend.scopes.invoke,
                account: account
            })
            .then((response) => {
                if(response) {
                    setToken(response.accessToken);
                }
            })
            .catch((error) => {
                const isInteractionError =
                    error instanceof InteractionRequiredAuthError ||
                    error?.errorCode === "login_required" ||
                    error?.errorCode === "interaction_required";

                if (isInteractionError && !hasRequestedInteraction.current) {
                    hasRequestedInteraction.current = true;
                    instance.acquireTokenRedirect({
                        scopes: protectedResources.adminPortalBackend.scopes.invoke,
                        account,
                    });
                }
            });
        }
    }, [account, instance, inProgress]);
 
    return token;
}

export const useGetData = (serviceFunction, payload = null, queryParams = null, dependencies = []) => {
    const [data, setData] = useState(null);
    const token = useGetToken();

    useEffect(() => {
        const getData = async () => {
            let queryConfig = {
                accessToken: token,
                payload: payload,
                params: queryParams
            };
            if (payload) queryConfig.payload = payload;
            const { data, error } = await serviceFunction(queryConfig);
            if (error) {
                console.error(error);
            } else {
                setData(data);
            }
        }
        token && getData();
    }, [...dependencies, serviceFunction, token, payload]);

    return data;
}